<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_PRE_TRANSFER')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch sử điều chuyển</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary" @click="backToTrans">
          <i class="bx bx-plus-circle"></i> Điều chuyển
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <div class="float-left w-auto box-search bs-left">
          <form class="box-search" @submit="submitForm">
            <div class="form-group">
              <input
                type="text"
                v-model.trim="search.textSearch"
                class="form-control f12 hc-37"
                placeholder="Từ khóa"
              />
            </div>
            <div class="form-group">
              <DateRangePicker
                placeholder="Thời gian"
                class="w-100"
                :ranges="false"
                @update="transfromDate()"
                v-model="dateRange"
                :locale-data="localeData"
              >
                <template v-slot:input="picker">
                  <label style="min-width: 13.5em" class="pt-1 text-center">
                    {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                  </label>
                </template>
              </DateRangePicker>
            </div>
            <div class="form-group">
              <Select2 placeholder="Vùng" v-model="search.regionId" :options="dataConfigRegion" />
            </div>
            <div
              class="form-group"
              v-if="
                dataUser.typeSale !== 'SALE' &&
                dataUser.typeSale !== 'AFTER_SALE' &&
                dataUser.typeSale !== 'TELESALE' &&
                dataUser.typeSale !== 'KEY_ACCOUNT'
              "
            >
              <Select2
                placeholder="Nguời thực hiện"
                v-model="search.transferSource"
                :options="dataSource"
              />
            </div>
            <div class="form-group">
              <Select2
                placeholder="Trạng thái"
                v-model="search.transferStatus"
                :options="dataStatus"
              />
            </div>
            <div class="d-inline-block">
              <a
                href="#"
                class="pt-2 mr-2 btn btn-primary hc-37 m-b-10"
                data-toggle="tooltip"
                data-placement="top"
                title="Lọc"
                @click="submitForm"
                >Áp dụng</a
              >
            </div>
          </form>
        </div>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="p-10">
            Tổng điều chuyển: {{ this.total || 0 }}
            <b-table
              :busy.sync="loading"
              hover
              sticky-header
              responsive
              :items="dataHistory"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <span
                  ><b>Tạo</b>: {{ data.item.createAt | formatDate('HH:mm') }},
                  {{ data.item.createAt | formatDate }}<br
                /></span>
                <span
                  v-if="data.item.transferStatus === 'RECEIVED' && data.item.receivedDate != null"
                  ><b>Nhận</b>: {{ data.item.receivedDate | formatDate('HH:mm') }},
                  {{ data.item.receivedDate | formatDate }}</span
                >
              </template>
              <template #cell(regionId)="data">
                Vùng {{ transfromRegion(data.item.regionId, dataConfigRegion) }}
              </template>
              <template #cell(transferStatus)="data">
                <span
                  class="badge"
                  :class="[data.item.transferStatus ? data.item.transferStatus : '']"
                >
                  {{ data.item.transferStatus | mapTextStatus(dataStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detailTrans(data.item)">Chi tiết</b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.transferStatus == 'PENDING' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_CSTM_MERCHANT_CANCEL_TRANSFER')
                    "
                    @click="cancelTrans(data.item)"
                    >Huỷ
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.transferStatus == 'PENDING' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_CSTM_MERCHANT_RECEIVE_TRANSFER')
                    "
                    @click="receiveTrans(data.item)"
                    >Đồng ý
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.transferStatus == 'PENDING' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_CSTM_MERCHANT_REFUSE_TRANSFER')
                    "
                    @click="refuseTrans(data.item)"
                    >Từ chối
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="total"
        :per-page="search.limit"
        class="mr-2 fl-right"
      ></b-pagination>
    </div>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { MerchantService } from '@/services/merchant.service'
  import { StaffService } from '@/services/staff.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian điều chuyển' },
    { key: 'numberOfcustomers', label: 'Số lượng MC' },
    { key: 'newSaleName', label: 'Sale nhận' },
    { key: 'managerName', label: 'Người thực hiện' },
    { key: 'regionId', label: 'Vùng kinh doanh' },
    { key: 'transferStatus', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    components: {
      DateRangePicker,
    },
    created() {
      this.fetchData()
      this.getRegions()
    },
    data() {
      return {
        loading: true,
        fieldsTable,
        filterTable: fieldsTable,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigRegion: [],
        dataStatus: [
          { text: 'Chờ xác nhận', id: 'PENDING' },
          { text: 'Đã nhận', id: 'RECEIVED' },
          { text: 'Từ chối', id: 'REFUSE' },
          { text: 'Đã hủy', id: 'CANCEL' },
        ],
        dataSource: [
          { text: 'Quản lý', id: 'MANAGER' },
          { text: 'Tự động', id: 'AUTO' },
        ],
        dataHistory: [],
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        search: {
          limit: 50,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        total: 0,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
      }
    },
    filters: {
      // lọc range ngày
      formatDatePicker(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },
      // lấy ngày
      formatDate(date) {
        return date.substring(0, 10)
      },
      // lấy giờ
      formatHour(date) {
        return date.substring(10, 16)
      },
    },
    watch: {
      'search.limit': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // chuyển về trang điều chuyển
      backToTrans() {
        this.$router.push({ path: '/trans-mc' })
      },
      // chuyển trang chi tiết lịch sử điều chuyển
      detailTrans(item) {
        window.open(`/history-trans/${item.transferId}`)
      },
      // chuyển dạng ngày, tháng
      transfromDate() {
        this.search.startDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      // lấy vùng dưới bảng
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      // nút lọc
      async submitForm(event) {
        event.preventDefault()
        this.fetchData()
      },
      // lọc vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return { id: e.id, text: e.name }
          })
        }
      },
      // hủy lệnh điều chuyển
      async cancelTrans(item) {
        if (item.managerEmail === this.dataUser.username) {
          try {
            const body = {
              transferId: item.transferId,
            }
            const data = await MerchantService.cancelTransfer(body)
            if (data.success) {
              this.notiModal = true
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.msgNoti = 'Thao tác thành công'
              this.fetchData()
            }
          } catch (error) {}
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // từ chối điều chuyển
      async refuseTrans(item) {
        if (item.newSaleEmail === this.dataUser.username) {
          try {
            const body = {
              transferId: item.transferId,
            }
            const data = await MerchantService.refuseTransfer(body)
            if (data.success) {
              await this.fetchData()
              this.notiModal = true
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.msgNoti = 'Thao tác thành công'
              this.fetchData()
            }
          } catch (error) {}
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // nhận điều chuyển
      async receiveTrans(item) {
        if (item.newSaleEmail === this.dataUser.username) {
          try {
            const body = {
              transferId: item.transferId,
            }
            const data = await MerchantService.receiveTransfer(body)
            if (data.success) {
              this.notiModal = true
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.msgNoti = 'Thao tác thành công'
              this.fetchData()
            }
          } catch (error) {}
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // dữ liệu bảng
      async fetchData() {
        this.loading = true
        this.search.userId = this.dataUser.userId
        if (this.search.regionId === '0') delete this.search.regionId
        if (this.search.transferStatus === '0') delete this.search.transferStatus
        if (this.search.managerName === '0') delete this.search.managerName
        try {
          this.search.userId = this.dataUser.userId
          const data = await MerchantService.historyTrans(this.search)
          if (data.success) {
            this.total = data.meta.pagination.total ? data.meta.pagination.total : 0
            this.dataHistory = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
